var map = {
	"./Chevron": 11,
	"./Chevron.js": 11,
	"./Datum": 22,
	"./Datum.js": 22,
	"./Googlebutton": 16,
	"./Googlebutton.js": 16,
	"./Group": 23,
	"./Group.js": 23,
	"./Handlereport": 24,
	"./Handlereport.js": 24,
	"./Info": 25,
	"./Info.js": 25,
	"./Menubutton": 26,
	"./Menubutton.js": 26,
	"./Modal": 27,
	"./Modal.js": 27,
	"./Name": 8,
	"./Name.js": 8,
	"./Picker": 28,
	"./Picker.js": 28,
	"./Progressbar": 19,
	"./Progressbar.js": 19,
	"./Regionpicker": 29,
	"./Regionpicker.js": 29,
	"./Report": 4,
	"./Report.js": 4,
	"./Scoreboard": 30,
	"./Scoreboard.js": 30,
	"./Settings": 31,
	"./Settings.js": 31,
	"./Setusername": 32,
	"./Setusername.js": 32,
	"./Signin": 33,
	"./Signin.js": 33,
	"./Signup": 7,
	"./Signup.js": 7,
	"./SpeciesPicker": 18,
	"./SpeciesPicker.js": 18,
	"./Subregionbutton": 34,
	"./Subregionbutton.js": 34,
	"./Subregions": 35,
	"./Subregions.js": 35,
	"./ToggleModal": 36,
	"./ToggleModal.js": 36,
	"./VenomPlusImage": 17,
	"./VenomPlusImage.js": 17,
	"./Venomreport": 5,
	"./Venomreport.js": 5,
	"./Zoom": 2,
	"./Zoom.js": 2,
	"./fetch": 3,
	"./fetch.js": 3,
	"./reports/Badidreport": 9,
	"./reports/Badidreport.js": 9,
	"./reports/Badregionreport.js": 15,
	"./reports/Badregionreport.js.js": 15,
	"./reports/Deadherpreport": 14,
	"./reports/Deadherpreport.js": 14,
	"./reports/Noherpreport": 13,
	"./reports/Noherpreport.js": 13,
	"./reports/Reportmanager": 12,
	"./reports/Reportmanager.js": 12,
	"./reports/Reportsinmodal": 6,
	"./reports/Reportsinmodal.js": 6,
	"./svgs/Alert": 1,
	"./svgs/Alert.js": 1,
	"./svgs/Check": 37,
	"./svgs/Check.js": 37,
	"./svgs/Eye": 38,
	"./svgs/Eye.js": 38,
	"./svgs/Question": 39,
	"./svgs/Question.js": 39,
	"./svgs/Swords": 40,
	"./svgs/Swords.js": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;